export default __webpack_public_path__ + "static/media/RightArrow.f94bf165.svg";